import api from "../services/api";

const updateLoadingText = async () => {
  try {
    const { data } = await api.get("/personalizations");
    const lightTheme = data.find((p) => p.theme === "light");
    const loadingText = document.querySelector(".loading-text");

    if (loadingText && lightTheme?.company) {
      loadingText.textContent = lightTheme.company;
    }
  } catch (error) {
    console.error("Erro ao carregar nome da empresa:", error);
  }
};

export const initializeLoading = () => {
  let progress = 0;
  let finished = false;
  const progressBar = document.getElementById("progress-bar");

  updateLoadingText();

  const interval = setInterval(() => {
    if (progress < 40) progress += 5;
    else if (progress < 70) progress += 2;
    else if (progress < 90) progress += 0.5;

    if (progressBar) {
      progressBar.style.width = progress + "%";
    }
  }, 80);

  return () => {
    if (finished) return;
    finished = true;
    clearInterval(interval);
    const splash = document.getElementById("splash-screen");

    if (progressBar) {
      progressBar.style.width = "100%";
    }

    if (!splash) return;

    setTimeout(() => {
      if (!splash.isConnected) return;

      splash.classList.add("fade-out");
      setTimeout(() => {
        if (splash.isConnected) {
          splash.remove();
        }
      }, 600);
    }, 500);
  };
};

export const showLoading = () => {
  const existingSplash = document.getElementById("splash-screen");
  if (existingSplash) existingSplash.remove();

  const splash = document.createElement("div");
  splash.id = "splash-screen";
  splash.innerHTML = `
    <div class="loading-container">
      <div class="loading-text">Carregando...</div>
      <div class="progress-container">
        <div class="progress-bar-bg">
          <div class="progress-bar" id="progress-bar"></div>
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(splash);

  updateLoadingText();
  return initializeLoading();
};
